import { useContext, useEffect } from 'react';
import { Box, Heading, Icon, Paragraph, TextButton } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useIdVerificationCallbacks } from '../../../IdvContext';
import { ExitReason } from '../../../../../models';
import { RENTER_CANNOT_IDV_HELP_URL } from '../../../constants/urls';
import { WizardContext } from '../../../wizard/WizardContext';

export default function ErrorForbiddenIpStep() {
  const { setOnNext } = useContext(WizardContext);
  const { onExit } = useIdVerificationCallbacks();

  useEffect(() => {
    setOnNext(() => async () => onExit({ reason: ExitReason.ForbiddenIp, success: false }));
    return () => setOnNext(null);
  }, [onExit, setOnNext]);

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default', alignItems: 'flex-start' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        We can’t complete your request
      </Heading>
      <Paragraph>
        It looks like you’re logged in from an IP address we don’t support, such as an international IP address or
        private server. You will not be able to ID verify.
      </Paragraph>
      <Paragraph>
        If you have access to a valid U.S. IP address or VPN (military or employer-provided), please connect to it to
        continue.
      </Paragraph>
      <TextButton asChild>
        <a href={RENTER_CANNOT_IDV_HELP_URL} target="_blank" rel="noopener noreferrer">
          Learn more
        </a>
      </TextButton>
    </Box>
  );
}
